var popoverList

window.addEventListener("turbolinks:load", () => {
  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="popover"]'))
  popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      html: true,
      sanitize: false,
    })
  })

  const twitterShareBtns = $(".twitter-share")

  twitterShareBtns.each((i, btn) => {
    btn.addEventListener("click", (ev) => {
      if (ev.currentTarget.dataset.metricClickUrl) { $.post(ev.currentTarget.dataset.metricClickUrl) }
    })
  })

  const fbShareBtns = $(".facebook-share")

  fbShareBtns.each((i, btn) => {
    btn.addEventListener("click", (ev) => {
      FB.init({
        appId: "311868219852867",
        xfbml: true,
        version: "v7.0",
      })

      FB.ui({
        method: "share",
        href: ev.currentTarget.dataset.url,
        display: "iframe",
      }, function(response) {
        console.log("shared if response === []...closed if response === undefined")
        if (response) {
          if (ev.currentTarget.dataset.metricShareUrl) { $.post(ev.currentTarget.dataset.metricShareUrl) }
        }
      })

      if (ev.currentTarget.dataset.metricClickUrl) { $.post(ev.currentTarget.dataset.metricClickUrl) }

      return false
    })
  })

  const linkedinShareBtns = $(".linkedin-share")

  linkedinShareBtns.each((i, btn) => {
    btn.addEventListener("click", (ev) => {
      if (ev.currentTarget.dataset.metricClickUrl) { $.post(ev.currentTarget.dataset.metricClickUrl) }
    })
  })

  const pinterestShareBtns = $(".pinterest-share")

  pinterestShareBtns.each((i, btn) => {
    pinterestShareBtns.addEventListener("click", (ev) => {
      if (ev.currentTarget.dataset.metricClickUrl) { $.post(ev.currentTarget.dataset.metricClickUrl) }
    })
  })

  const emailShareBtns = $(".email-share")

  emailShareBtns.each((i, btn) => {
    btn.addEventListener("click", (ev) => {
      if (ev.currentTarget.dataset.metricClickUrl) { $.post(ev.currentTarget.dataset.metricClickUrl) }
    })
  })

  const copyLinkBtns = $(".link-share")

  copyLinkBtns.each((i, btn) => {
    btn.addEventListener("click", (ev) => {
      ev.preventDefault()
      if (ev.currentTarget.dataset.metricClickUrl) { $.post(ev.currentTarget.dataset.metricClickUrl) }
      setTimeout(() => { $(".share-link-field").select() }, 1)
    })
  })
})

$(document).on("click", ".share-link-field", (ev) => {
  $(ev.currentTarget).select()
})

$(document).on("click", ".share-link-btn", (ev) => {
  ev.preventDefault()
  $(".share-link-field").select()
  document.execCommand("copy")
  popoverList.forEach((p) => p.hide())
})
